import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const sanitizeSheetName = (name) => String(name || "Sheet1").replace(/[\\/?*[\]:]/g, " ").slice(0, 31);

const setColumnWidths = (sheet, rows) => {
  const widthCount = rows.reduce((max, row) => Math.max(max, row.length), 0);
  sheet["!cols"] = Array.from({ length: widthCount }, (_, columnIndex) => ({
    wch: Math.min(
      45,
      Math.max(
        12,
        ...rows.map((row) => String(row[columnIndex] ?? "").length + 2),
      ),
    ),
  }));
};

export function exportDashboardRowsToExcel({
  filename = `lud-dashboard-${Date.now()}.xlsx`,
  sheetName = "Dashboard",
  rows = [],
}) {
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.aoa_to_sheet(rows);
  setColumnWidths(worksheet, rows);
  XLSX.utils.book_append_sheet(workbook, worksheet, sanitizeSheetName(sheetName));

  const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  saveAs(
    new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    filename.endsWith(".xlsx") ? filename : `${filename.replace(/\.[^.]+$/, "")}.xlsx`,
  );
}

